import { link } from "@/components/Action.tsx";
import type { VirtualMachineLoc } from "@/modules/compute/vmQuery.ts";

export function vmLink({ uuid, location }: VirtualMachineLoc) {
    return link({ to: "/compute/vm/$location/$vmId", params: { location, vmId: uuid } });
}
